import { split } from 'value-units';

/**
 * We will parse some importation information that are present in the labeledRecords
 * @param labeledRecords
 */

export function getMetaTGA(labeledRecords) {
  let meta = {};
  if (labeledRecords.get('Method')) {
    meta.method = labeledRecords.get('Method');
  }
  if (labeledRecords.get('Sample Holder')) {
    meta.holder = parseHolder(labeledRecords.get('Sample Holder'));
  }
  meta.initialValue = split(labeledRecords.get('Initial Value'));
  if (labeledRecords.has('Results')) {
    meta.zones = parseResults(labeledRecords.get('Results'));
  }
  return meta;
}

function parseHolder(text) {
  if (!text) return {};
  let holder = {};
  let lines = text.split('\n');
  for (let line of lines) {
    if (line.includes(':')) {
      let fields = line.split(':', 2);
      let label = fields[0].trim().toLowerCase();
      let value = fields[1].trim();
      switch (label) {
        case 'weight':
          holder.mass = split(value);
          break;
        case 'material':
          holder[label] = value;
          break;
        default:
      }
    } else {
      holder.kind = line.trim();
    }
  }
  return holder;
}

function parseResults(text) {
  let results = [];
  let result = {};
  let lines = text.split('\n');
  for (let i = 0; i < lines.length; i++) {
    let line = lines[i];
    let nextLine = lines[i + 1];
    line = line.replace(/^\? /, '');
    if (line.includes('Step')) {
      result = {};
      results.push(result);
      if (!line.includes('%')) {
        throw new Error('tga parsing problem, step does not contain %');
      }
      result.relativeMassLoss =
        Number(line.replace(/^.*Step(.*)%.*/, '$1')) / -100;
      result.massLoss = split(nextLine, { factor: -1 });
    } else if (line.startsWith('Type')) {
      result.kind = line.replace('Type', '').trim();
    } else if (line.startsWith('Left Limit')) {
      result.from = split(line.replace('Left Limit', ''));
    } else if (line.startsWith('Right Limit')) {
      result.to = split(line.replace('Right Limit', ''));
    } else if (line.startsWith('Midpoint')) {
      result.middlePoint = split(line.replace('Midpoint', ''));
    } else if (line.startsWith('Inflect. Pt.')) {
      result.inflectionPoint = split(line.replace('Inflect. Pt.', ''));
    }
  }
  return results;
}
